export default "assets/images/a-ne-pas-manquer-fr-4e9bec4b.svg";